import React from "react";
import UnifiedInboxMessagingPage from "./UnifiedInboxMessagingPage";

export default function WhatsAppInboxPage() {
  return (
    <UnifiedInboxMessagingPage
      initialChannel="whatsapp"
      channelLocked
      title="WhatsApp Inbox"
      eyebrow="WhatsApp Queue"
      description="Monitor inbound WhatsApp conversations, assign ownership quickly, and keep inquiry context visible without leaving the queue."
    />
  );
}
